function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.182,2.182L13.091,2.182L13.091,4.364L2.182,4.364L2.182,19.636L17.455,19.636L17.455,15.273L19.636,15.273L19.636,19.636C19.636,20.836 18.655,21.818 17.455,21.818L2.182,21.818C0.982,21.818 0,20.836 0,19.636L0,4.364C0,3.164 0.982,2.182 2.182,2.182ZM10.909,6.545L8.727,6.545L8.727,17.455L10.909,17.455L10.909,6.545ZM6.545,9.818L4.364,9.818L4.364,17.455L6.545,17.455L6.545,9.818ZM13.091,12L15.273,12L15.273,17.455L13.091,17.455L13.091,12ZM17.455,2.182L19.636,2.182L19.636,6.545L24,6.545L24,8.727L19.636,8.727L19.636,13.091L17.455,13.091L17.455,8.727L13.091,8.727L13.091,6.545L17.455,6.545L17.455,2.182Z",
    style: {
      fill: "white"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.4f386339.svg";
export { ForwardRef as ReactComponent };